import { useEffect } from 'react';

import { useUserId } from 'hooks/useCurrentUser';
import usePlanType from 'hooks/usePlanType';
import { apiAdvisor } from 'services/apiService';
import { logger } from 'utils/logger';

const usePingOnline = () => {
  const userId = useUserId();
  const planType = usePlanType();

  useEffect(() => {
    if (!planType.isAdvisor) {
      logger.debug('User is not an Advisor, ping not started.');
      return;
    }

    let intervalId: NodeJS.Timeout | null = null;

    const sendPing = async (idAdvisor: string) => {
      try {
        await apiAdvisor.patch(`/v1/advisors/${idAdvisor}/ping-online`);
        logger.debug('Ping sent successfully to Advisor:', { data: idAdvisor });
      } catch (error) {
        logger.error('Failed to send ping:', error);
      }
    };

    const fetchAdvisorIdAndStartPing = async () => {
      if (userId) {
        try {
          const response = await apiAdvisor.get<{ id: string }>(
            `/v1/advisors/by-user-id/${userId}`
          );
          const idAdvisor = response.data.id;

          if (idAdvisor) {
            logger.debug('Advisor ID found:', { data: idAdvisor });
            sendPing(idAdvisor);
            intervalId = setInterval(() => {
              sendPing(idAdvisor);
            }, 150000);
          } else {
            logger.debug('Advisor ID not found for user:', { data: userId });
          }
        } catch (error) {
          logger.error('Failed to fetch advisor ID:', error);
        }
      }
    };

    fetchAdvisorIdAndStartPing();

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        logger.debug('Ping interval cleared');
      }
    };
  }, [userId, planType.isAdvisor]);
};

export default usePingOnline;
